module.exports = __webpack_public_path__ + "img/16m008-06.cacebd9d.png";